import Breadcrumbs from '~/client/shared/Breadcrumbs';
import Translate from '~/client/shared/i18n/Translate';
import BlogCategories from './BlogCategories';

type Props = {
  title?: string;
  breadcrumbs?: Breadcrumb[];
};

const SubHeaderInfo: FC<Props> = ({
  title,
  breadcrumbs = [{ translateId: 'blog.blog' }],
}) => (
  <>
    {title && (
      <h2 className="text-2xl font-medium">
        <Translate id={title} />
      </h2>
    )}
    <div className="grid grid-flow-col items-baseline justify-between gap-4">
      <Breadcrumbs showLogo={false} breadcrumbs={breadcrumbs} size="large" />
      <BlogCategories />
    </div>
  </>
);

export default SubHeaderInfo;
